import { stateStatusType, QuationProps } from './actionType';

export interface FetchQuestionsState {
    isLoading: boolean;
    error: string | null;
    questions: QuationProps[];
    status: stateStatusType | null;
    delete: string | null;
}
export interface GenericQuestionsState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
    question: QuationProps | null;
}
export const initalQuestionsState: FetchQuestionsState = {
    isLoading: false,
    error: null,
    questions: [],
    status: null,
    delete: null,
};
export const initalGenericQuestionsState: GenericQuestionsState = {
    isLoading: false,
    error: null,
    status: null,
    question: null
};
export interface QuestionsState {
    questionsState: FetchQuestionsState;
    genericQuestionsState: GenericQuestionsState;
}

export const initialState: QuestionsState = {
    questionsState: initalQuestionsState,
    genericQuestionsState: initalGenericQuestionsState
};


